import baseAPI from "@/api/base";
import { EditOpportunity, GetOpportunity, RegisterOpportunity } from "@/dtos/Opportunity.dto";
import {
  DELETE_OPPORTUNITY_URL,
  EDIT_OPPORTUNITY_URL,
  GET_OPPORTUNITY_URL,
  MOVE_OPPORTUNITY_URL,
  REGISTER_OPPORTUNITY_URL,
  TOGGLE_OPPORTUNITY_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class Opportunity {
  static getOpportunities = async (getOpportunity: GetOpportunity): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_OPPORTUNITY_URL, {
      params: getOpportunity,
    });
    return response;
  };

  static registerOpportunity = async (
    registerOpportunity: RegisterOpportunity
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_OPPORTUNITY_URL, {
      ...registerOpportunity,
    });
    return response;
  };

  static editOpportunity = async (editOpportunity: EditOpportunity): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_OPPORTUNITY_URL, {
      ...editOpportunity,
    });
    return response;
  };

  static moveOpportunity = async (editOpportunity: EditOpportunity): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(MOVE_OPPORTUNITY_URL, {
      ...editOpportunity,
    });
    return response;
  };

  static toggleOpportunityIsActive = async (
    editOpportunity: EditOpportunity
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_OPPORTUNITY_IS_ACTIVE_URL, {
      ...editOpportunity,
    });
    return response;
  };

  static deleteOpportunity = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_OPPORTUNITY_URL}/${id}`);
    return response;
  };
}

export default Opportunity;
